import type { MouseEvent } from 'react';
import { buildUserProfileHref, buildUserProfilePath } from '../../utils/userProfileNavigation';

type MissionUserLinkProps = {
  userId: number;
  displayName: string;
  currentUserId: number;
  portalPath: string;
  onNavigate: (path: string) => void;
  className?: string;
};

const MissionUserLink = ({
  userId,
  displayName,
  currentUserId,
  portalPath,
  onNavigate,
  className,
}: MissionUserLinkProps) => {
  const path = buildUserProfilePath(userId, currentUserId);
  const href = buildUserProfileHref(portalPath, userId, currentUserId);
  const linkClassName = ['mission-user-link', className].filter(Boolean).join(' ');

  const handleClick = (event: MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    onNavigate(path);
  };

  return (
    <a className={linkClassName} href={href} onClick={handleClick}>
      {displayName}
    </a>
  );
};

export default MissionUserLink;
